import { useEffect } from 'react';

import { useSession } from '@hooks/useSession';

import { useSetBulkViewedStatus } from './api/extension';

interface BulkViewableParams {
  resource_name: string;
  category?: string;
}

const viewedCategories = new Set<string>();
const pendingCategories = new Set<string>();

function getKey(patient_id: string, resource_name: string, category?: string) {
  return `${patient_id}:${resource_name}:${category ?? ''}`;
}

export function useBulkViewable({
  resource_name,
  category,
}: BulkViewableParams) {
  const [setBulkViewedStatus] = useSetBulkViewedStatus();
  const {
    state: { activeProfile, isClient },
  } = useSession();

  useEffect(() => {
    if (!activeProfile?.patient_id || !isClient) return;

    const key = getKey(activeProfile.patient_id, resource_name, category);
    if (viewedCategories.has(key) || pendingCategories.has(key)) return;

    pendingCategories.add(key);
    setBulkViewedStatus({
      input: {
        patient_id: activeProfile.patient_id,
        resource_name,
        category,
      },
    })
      .then(() => {
        viewedCategories.add(key);
      })
      .finally(() => {
        pendingCategories.delete(key);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeProfile?.patient_id, isClient]);
}
